import { useRef, useState, useEffect } from "react";
import "./gallery-updated.css";
import client from '../../sanityClient';
import RightArrow from '../../assets/galleryrightarrow.svg';
import LeftArrow from '../../assets/galleryleftarrow.svg';



export default function Gallery() {
    const scrollRef = useRef(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [activeItem, setActiveItem] = useState(null);
    const [images, setImages] = useState([]);

    const scroll = (direction) => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({
                left: direction === "left" ? -220 : 220,
                behavior: "smooth",
            });
        }
    };

    useEffect(() => {
            client
                .fetch(`*[_type == "galleryImage"][0...12]{
          "src": image.asset->url,
          description,
        }`)
                .then((data) => setImages(data));
        }, []);
    

    // add your images here
    const galleryItems = images.map((img,index) => ({id: index, src: img.src}));
    return (
        <section className="gallery-section">
            <h2 className="gallery-title" style={{fontFamily:'CabinetGrotesk-Extrabold'}}>
                GALLERY
            </h2>

            <div className="gallery-container">
                <div
                    ref={scrollRef}
                    className="gallery-scroll-container"
                >
                    <div className="gallery-grid">
                        {galleryItems.map((item) => (
                            <div
                                key={item.id}
                                onClick={() => {
                                    setActiveItem(item);
                                    setModalOpen(true);
                                }}
                                className={`gallery-item `}
                            >
                                <img
                                    src={item.src}
                                    alt="Gallery item"
                                />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Scroll Buttons */}
                <button
                    onClick={() => scroll("left")}
                    className="scroll-button scroll-button-left"
                >
                    <img src={LeftArrow} alt="Left" />
                </button>
                <button
                    onClick={() => scroll("right")}
                    className="scroll-button scroll-button-right"
                >
                    <img src={RightArrow} alt="Right" />
                </button>

                {/* Enlarged View */}
                {modalOpen && activeItem && (
                    <div className="modal-overlay">
                        <div
                            onClick={() => setModalOpen(false)}
                            className="modal-content"
                        >
                            <img
                                src={activeItem.src}
                                className="modal-image"
                            />
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}
